var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5435 27.9713V33.0438C25.5435 33.444 25.219 33.7684 24.8188 33.7684H16.1232C15.723 33.7684 15.3986 33.444 15.3986 33.0438V27.9713M25.5435 27.9713H15.3986M25.5435 27.9713V22.1742M15.3986 27.9713V22.1742M15.3986 22.1742H25.5435M15.3986 22.1742L15.3986 17.1018C15.3986 16.7016 15.723 16.3771 16.1232 16.3771H24.8188C25.219 16.3771 25.5435 16.7016 25.5435 17.1018V22.1742M16.8478 7.68148H13.9493C13.1489 7.68148 12.5 8.33034 12.5 9.13076L12.5 35.2177C12.5 36.0181 13.1489 36.667 13.9493 36.667H26.9928C27.7932 36.667 28.442 36.0181 28.442 35.2177V9.13076C28.442 8.33034 27.7932 7.68148 26.9928 7.68148H24.0942V4.78293C24.0942 3.98252 23.4453 3.33365 22.6449 3.33365H18.2971C17.4967 3.33365 16.8478 3.98252 16.8478 4.78293V7.68148Z",
    stroke: "#1ED760",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBattery);
export default __webpack_public_path__ + "static/media/ic-battery.396fa38a.svg";
export { ForwardRef as ReactComponent };